import script from "./DuellyTokenUserWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./DuellyTokenUserWallet.vue?vue&type=script&setup=true&lang=js"

import "./DuellyTokenUserWallet.vue?vue&type=style&index=0&id=1f83b649&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f83b649"]])

export default __exports__